<template>
    <div class="container">
        <div class="goods">
            <h3 class="goods-title"
                v-show="whetherSticky">{{shopName}}</h3>
            <div class="goods-header"
                 ref="goodsHeader">
                <div class="ground">
                    <div class="ground-cover"></div>
                </div>
                <div class="info">
                    <div class="info-card">
                        <h3 class="card-title">
                            <p class="title">{{ shopName }}</p>
                        </h3>
                        <div class="card-content">
                            <div class="picture">
                                <img :src="shopLogo || defaultLogo"
                                     @error="e => { e.target.src = defaultLogo }" />
                            </div>
                            <div class="describe">
                                <van-button type="info" size="small" round @click="allergenShow = true">{{ $t('selectAllergen') }}</van-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <van-tabs class="goods-list"
                      offset-top="1.06667rem"
                      id="tabs"
                      ref="tabs"
                      v-model="active"
                      scrollspy
                      sticky
                      :ellipsis="false"
                      @scroll="tabScroll"
                      v-if="goodsList.length > 0">
                <van-tab :title="item.name"
                         v-for="item in goodsList"
                         :key="item.id">
                    <p class="nav-item-title">{{ item.name }}</p>
                    <ul class="list">
                        <li class="list-item"
                            v-for="food in item.items"
                            :key="food.id">
                            <!-- 单品 -->
                            <div class="item" @click="dishesHandle(food.id, food.multiSpec)" v-if="food.type === 101">
                                <div class="picture">
                                    <!-- 图片 -->
                                    <img class="food-img"
                                         v-lazy="cutImage(food.image, 200)"
                                         v-if="food.image">
                                    <img class="food-img"
                                         src="../assets/images/default.png"
                                         v-else>
                                    <!-- 售罄 -->
                                    <div class="cover"
                                         v-if="food.stock === 0">
                                        <div class="cover-in">
                                            <p class="text">{{ $t('sellOut') }}</p>
                                        </div>
                                    </div>
                                    <!-- 过敏源 -->
                                    <div class="allergen"
                                         v-else-if="(food.checkFlags & 0x00000010) === 0x00000010">
                                        <p class="text">{{ $t('includeAllergen') }}</p>
                                    </div>
                                    <!-- 提示 -->
                                    <div class="hint-icon">
                                        <img src="../assets/images/xin.png"
                                             class="icon xin"
                                             v-if="food.newest">
                                        <img src="../assets/images/la.png"
                                             class="icon la"
                                             v-if="food.spiciest">
                                        <img src="../assets/images/leng.png"
                                             class="icon leng"
                                             v-if="food.coldest">
                                        <img src="../assets/images/su.png"
                                             class="icon su"
                                             v-if="food.vegetable">
                                    </div>
                                    <!-- 打折 -->
                                    <div class="discount-icon" v-if="food.discountable">
                                        <img src="../assets/images/discount.png">
                                    </div>
                                    <!-- 限制份数 -->
                                    <p class="mark" v-if="food.remainCount">{{ food.remainCount }}</p>
                                </div>
                                <div class="describe">
                                    <p class="name">
                                        <img src="../assets/images/edit.png" class="type-icon" v-if="food.multiSpec">
                                        {{food.name}}
                                    </p>
                                    <p class="code">{{ food.code }}</p>
                                    <div class="chunk">
                                        <p class="price"
                                           v-if="food.dynamicPrice">{{ $t('currentPrice') }}</p>
                                        <p class="price"
                                           v-else>{{ food.price | filterPrice }}€</p>
                                    </div>
                                </div>
                            </div>
                            <!-- 套餐 -->
                            <div class="item" @click="setMealHandle(food.id)" v-else-if="food.type === 102">
                                <div class="picture">
                                    <!-- 图片 -->
                                    <img class="food-img"
                                         v-lazy="cutImage(food.image, 200)"
                                         v-if="food.image">
                                    <img class="food-img"
                                         src="../assets/images/default.png"
                                         v-else>
                                    <!-- 售罄 -->
                                    <div class="cover"
                                         v-if="food.stock === 0">
                                        <div class="cover-in">
                                            <p class="text">{{ $t('sellOut') }}</p>
                                        </div>
                                    </div>
                                    <!-- 提示 -->
                                    <div class="hint-icon">
                                        <img src="../assets/images/xin.png" class="icon xin" v-if="food.newest">
                                    </div>
                                    <!-- 打折 -->
                                    <div class="discount-icon" v-if="food.discountable">
                                        <img src="../assets/images/discount.png">
                                    </div>
                                    <!-- 限制份数 -->
                                    <p class="mark" v-if="food.remainCount">{{ food.remainCount }}</p>
                                </div>
                                <div class="describe">
                                    <p class="name">
                                        <img src="../assets/images/fastfood.png" class="type-icon">
                                        {{food.name}}
                                    </p>
                                    <p class="code">{{ food.code }}</p>
                                    <div class="chunk">
                                        <p class="price">{{ food.price | filterPrice }}€</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>
            <!-- 返回顶部 -->
            <div class="back-top"
                 @click.stop="backTopHandle"
                 v-if="whetherSticky">
                <van-icon name="back-top" class="icon" />
            </div>
            <!-- 过敏源 -->
            <Allergen
                :parentShow="allergenShow"
                :allergenList="allergenList"
                @parent-update="getMenuInfo"
                @parent-close="allergenShow = false"/>
        </div>
    </div>
</template>

<script>
import {queryMenuPreview} from "@/api";
import defaultLogo from '@/assets/images/pointsme.png'
import {mapMutations, mapState} from "vuex";
import Allergen from "@/components/menu-mobile/Allergen";
export default {
    name: "MenuMobile",
    // 组件
    components: {
        Allergen
    },
    props: {},
    data() {
        return {
            shopName: '',
            shopLogo: '',
            goodsList: [],
            defaultLogo: defaultLogo,
            active: '',
            whetherSticky: false,
            allergenList: [],
            allergenShow: false
        };
    },
    // 计算属性
    computed: {
        ...mapState(['allergenIds'])
    },
    filters: {
        filterPrice (val) {
            if (val) {
                let value = Number(val)
                return value.toFixed(2).replace(/\./g, ',')
            } else {
                return 0
            }
        }
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ...mapMutations(['saveMenuId']),
        // 获取菜单预览信息
        getMenuInfo () {
            let params = {
                menuId: this.$route.params.id,
                allergenIds: this.allergenIds
            }
            queryMenuPreview(params).then(res => {
                if (Number(res.code) === 20000) {
                    if (!res.data) {
                        return
                    }
                    if (res.data.shop) {
                        this.shopName = res.data.shop.name
                        this.shopLogo = res.data.shop.logo
                    }
                    this.goodsList = res.data.categories || []
                    // 过敏源
                    this.allergenList = res.data.allergens
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
    
        // 裁减图片
        cutImage (url, w = 200) {
            if (!url) return ''
            let suffix = url.substring(url.lastIndexOf('.'))
            return `${url}_${w}-${suffix}`
        },
    
        // 当前导航条的吸附状态发生改变
        tabScroll (data) {
            if (data.isFixed) {
                this.whetherSticky = true
            } else {
                this.whetherSticky = false
            }
        },
    
        // 菜品详情
        dishesHandle (id, multiSpec) {
            if (multiSpec) {
                // 跳转详情
                this.$router.push({
                    name: 'RawMaterial',
                    params: {
                        id
                    }
                })
            } else {
                // 跳转详情
                this.$router.push({
                    name: 'DishesDetail',
                    params: {
                        id
                    }
                })
            }
        },
        // 套餐详情
        setMealHandle (id) {
            // 跳转详情
            this.$router.push({
                name: 'SetMeal',
                params: {
                    id
                }
            })
        },
    
        // 返回顶部
        backTopHandle () {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        if (this.$route.params.id) {
            this.saveMenuId(this.$route.params.id)
            this.getMenuInfo()
        }
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
.container{
    .goods {
        width: 100%;
        height: 100%;
        padding-bottom: 20px;
        .goods-title {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: #01000d;
            z-index: 99;
            background-color: #ffffff;
            .icon {
                position: absolute;
                right: 30px;
                top: 10px;
                height: 20px;
            }
        }
        .goods-header {
            padding-bottom: 15px;
            .ground {
                width: 100%;
                height: 140px;
                background-image: url('../assets/images/dish.png');
                background-repeat: no-repeat;
                background-size: 100% auto;
                .ground-cover{
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.6);
                }
            }
            .info {
                width: 100%;
                height: 120px;
                position: relative;
                background: #ffffff;
                .info-card {
                    position: absolute;
                    left: 18px;
                    right: 18px;
                    top: -24px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    background-color: #fafafa;
                    border-radius: 24px 24px 0 0;
                    .card-title {
                        width: 100%;
                        height: 60px;
                        padding-left: 10px;
                        padding-right: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .title{
                            max-height: 100%;
                            font-size: 24px;
                            color: #01000d;
                            font-weight: 600;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                    }
                    .card-content {
                        width: 100%;
                        height: 74px;
                        padding-top: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .picture {
                            width: 64px;
                            height: 64px;
                            border-radius: 4px;
                            overflow: hidden;
                            flex-shrink: 0;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .describe{
                            padding-left: 10px;
                            .van-button--info{
                                background-color: #328969;
                                border: none;
                            }
                        }
                    }
                }
            }
        }
        ::v-deep .van-tabs {
            display: flex;
            justify-content: space-between;
            .van-sticky {
                transform: none !important;
                position: fixed;
                .van-tabs__nav {
                    position: relative;
                    display: block;
                    padding-top: 20px;
                    border-radius: 0 16px 0 0;
                    background-color: #eeeeee;
                    -webkit-user-select: none;
                    user-select: none;
                    padding-bottom: 64px;
                    box-sizing: border-box;
                    .van-tab {
                        display: block;
                        padding: 12px 8px;
                        .nav-bar-item {
                            position: relative;
                            word-break: break-all;
                            .mark {
                                position: absolute;
                                top: -10px;
                                right: -8px;
                                min-width: 16px;
                                padding-left: 3px;
                                padding-right: 3px;
                                height: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 8px;
                                background: #fea808;
                                color: #ffffff;
                                font-size: 10px;
                            }
                        }
                        &.van-tab--active {
                            .nav-bar-item {
                                color: #197340;
                            }
                            &::before {
                                height: 100%;
                                background-color: #197340;
                            }
                        }
                    }
                }
                
                .van-tabs__wrap--scrollable .van-tabs__nav {
                    overflow-x: hidden;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                }
                
                .van-tabs__nav--line.van-tabs__nav--complete {
                    padding-right: 0px;
                    padding-left: 0px;
                    position: fixed;
                    left: 0;
                }
                
                .van-tabs__nav--line.van-tabs__nav--complete {
                    padding-right: 0px;
                    padding-left: 0px;
                }
                
                .van-tabs__wrap {
                    height: 100%;
                    width: auto;
                    overflow-y: auto;
                }
                
                .van-tabs__line {
                    display: none;
                }
                
                .van-tab {
                    //position: relative;
                    width: 94px;
                    height: auto;
                    padding: 10px;
                    .van-tab__text {
                        line-height: 22px;
                        text-align: center;
                        //overflow: visible;
                    }
                }
                
                .van-tab--active {
                    color: red;
                    background-color: white;
                }
                
                .van-tab--active::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    width: 4px;
                    height: 16px;
                    background-color: #ee0a24;
                    -webkit-transform: translateY(-50%);
                    transform: translateY(-50%);
                    content: '';
                }
            }
            .van-tabs__content {
                background-color: white;
                width: calc(100% - 94px);
                //height: 100%;
                //overflow-y: auto;
                padding-bottom: 10px;
            }
        }
        .goods-list {
            .nav-item-title {
                width: 100%;
                height: 30px;
                padding-left: 10px;
                padding-right: 10px;
                line-height: 30px;
                font-size: 12px;
                color: rgba(32, 32, 32, 0.5);
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .list {
                .list-item {
                    .item{
                        width: 100%;
                        height: 100px;
                        padding: 10px;
                        display: flex;
                        .picture {
                            width: 80px;
                            height: 80px;
                            flex-shrink: 0;
                            position: relative;
                            background-color: #f0f0f0;
                            border-radius: 4px;
                            overflow: hidden;
                            .food-img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 4px;
                            }
                            .cover {
                                position: absolute;
                                z-index: 9;
                                left: 0;
                                top: 0;
                                width: 100%;
                                height: 100%;
                                background-color: rgba(0, 0, 0, 0.6);
                                .cover-in {
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background-image: url('../assets/images/seal.png');
                                    background-size: contain;
                                    background-repeat: no-repeat;
                                    background-position: center center;
                                    .text {
                                        width: 100%;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        font-size: 12px;
                                        //color: #E20714;
                                        color: #FDBB4D;
                                        text-align: center;
                                        transform: rotate(-15deg);
                                    }
                                }
                            }
                            .hint-icon {
                                position: absolute;
                                left: 0;
                                top: 0;
                                z-index: 6;
                                display: flex;
                                flex-direction: column;
                                .icon {
                                    width: 18px;
                                    margin-bottom: 2px;
                                }
                            }
                            .discount-icon{
                                position: absolute;
                                right: 2px;
                                bottom: 2px;
                                z-index: 6;
                                width: 18px;
                                height: 18px;
                                img{
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }
                            .mark {
                                position: absolute;
                                right: 0;
                                top: 0;
                                z-index: 6;
                                min-width: 16px;
                                padding-left: 3px;
                                padding-right: 3px;
                                height: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 8px;
                                background: #fea808;
                                color: #ffffff;
                                font-size: 10px;
                            }
                            .allergen{
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                width: 100%;
                                height: 20px;
                                z-index: 9;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background-color: rgba(0, 0, 0, 0.6);
                                .text{
                                    font-size: 10px;
                                    color: #FDBB4D;
                                }
                            }
                        }
                        .describe {
                            flex-grow: 1;
                            height: 100%;
                            padding-left: 20px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            overflow: hidden;
                            .name {
                                width: 100%;
                                font-size: 16px;
                                line-height: 18px;
                                height: 36px;
                                color: #01000d;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                .type-icon{
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 3px;
                                }
                            }
                            .code {
                                font-size: 12px;
                                color: #8f92a1;
                            }
                            .chunk {
                                width: 100%;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .price {
                                    flex-grow: 1;
                                    font-size: 16px;
                                    color: #E20714;
                                }
                            }
                        }
                    }
                }
            }
        }
        .back-top{
            position: fixed;
            right: 20px;
            bottom: 20px;
            z-index: 100;
            .icon {
                font-size: 24px;
                color: #2f7a59;
                font-weight: 600;
            }
        }
    }
}
</style>
